var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('HeaderView',{staticClass:"head",attrs:{"titles":_vm.titles},on:{"jumpPage":_vm.jumpPageCallback}}),_c(_vm.currentView,{tag:"component"}),_c('FooterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }